<template>
  <div class="transactions-table-pagination">
    <div
      class="transactions-table-pagination__item"
      v-for="(page, i) in pagesList"
      :key="`page-${i}`"
    >
      <div
        class="transactions-table-pagination__item-button transactions-table-pagination__item-button--prev"
        v-if="page.type === 'prev-button'"
        @click="goToPrevPage"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          style="transform: rotate(180deg)"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="29"
            height="29"
            rx="9.5"
            stroke="#E0E6F2"
          />
          <path
            d="M17.5243 14.6491L14.0016 11.1265C13.9201 11.0449 13.8114 11 13.6954 11C13.5794 11 13.4706 11.0449 13.3892 11.1265L13.1297 11.3858C12.9609 11.5548 12.9609 11.8295 13.1297 11.9982L16.0879 14.9564L13.1265 17.9178C13.045 17.9993 13 18.108 13 18.2239C13 18.34 13.045 18.4487 13.1265 18.5303L13.3859 18.7896C13.4674 18.8711 13.5761 18.916 13.6921 18.916C13.8081 18.916 13.9168 18.8711 13.9983 18.7896L17.5243 15.2637C17.606 15.1819 17.6509 15.0727 17.6506 14.9566C17.6509 14.84 17.606 14.7309 17.5243 14.6491Z"
            fill="#666D79"
          />
        </svg>
      </div>
      <div
        class="transactions-table-pagination__item-page"
        :class="{ active: page.active }"
        v-if="page.type === 'page'"
        @click="goToPage(page.text)"
      >
        {{ page.text }}
      </div>
      <div
        class="transactions-table-pagination__item-dots"
        v-if="page.type === 'dots'"
      >
        {{ page.text }}
      </div>
      <div
        class="transactions-table-pagination__item-button transactions-table-pagination__item-button--next"
        v-if="page.type === 'next-button'"
        @click="goToNextPage"
      >
        <svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="29"
            height="29"
            rx="9.5"
            stroke="#E0E6F2"
          />
          <path
            d="M17.5243 14.6491L14.0016 11.1265C13.9201 11.0449 13.8114 11 13.6954 11C13.5794 11 13.4706 11.0449 13.3892 11.1265L13.1297 11.3858C12.9609 11.5548 12.9609 11.8295 13.1297 11.9982L16.0879 14.9564L13.1265 17.9178C13.045 17.9993 13 18.108 13 18.2239C13 18.34 13.045 18.4487 13.1265 18.5303L13.3859 18.7896C13.4674 18.8711 13.5761 18.916 13.6921 18.916C13.8081 18.916 13.9168 18.8711 13.9983 18.7896L17.5243 15.2637C17.606 15.1819 17.6509 15.0727 17.6506 14.9566C17.6509 14.84 17.606 14.7309 17.5243 14.6491Z"
            fill="#666D79"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
export default {
  name: 'TransactionsTablePagination',
  props: {
    itemsCount: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      gap: 2,
    }
  },
  computed: {
    pagesCount() {
      return parseInt(Math.ceil(this.itemsCount / this.perPage))
    },
    pagesList() {
      let _pages = []
      if (this.currentPage > 1) {
        _pages.push({
          type: 'prev-button',
          text: '',
          active: false,
        })
      }

      for (let i = 1; i <= this.pagesCount; i++) {
        if (Math.abs(i - this.currentPage) === this.gap + 1) {
          _pages.push({
            type: 'dots',
            text: '...',
            active: false,
          })
        }
        if (
          Math.abs(i - this.currentPage) <= this.gap ||
          i === this.pagesCount ||
          i === 1
        ) {
          _pages.push({
            type: 'page',
            text: i,
            active: this.currentPage === i,
          })
        }
      }

      if (this.currentPage <= this.pagesCount - 1) {
        _pages.push({
          type: 'next-button',
          text: '',
          active: false,
        })
      }

      return _pages
    },
  },
  methods: {
    goToPrevPage() {
      $emit(this, 'changePage', this.currentPage - 1)
    },
    goToPage(page) {
      if (parseInt(page) === this.currentPage) {
        return
      }

      $emit(this, 'changePage', parseInt(page))
    },
    goToNextPage() {
      $emit(this, 'changePage', this.currentPage + 1)
    },
  },
  emits: ['changePage'],
}
</script>

<style lang="scss" scoped>
.transactions-table-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin: 35px 0;
  &__item {
    &-button {
      width: 30px;
      height: 30px;

      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &--prev {
        margin-right: 10px;
      }

      &--next {
        margin-left: 20px;
      }

      svg {
        width: 100%;
        height: 100%;
      }

      &:hover {
        opacity: 0.8;
      }
    }

    &-page {
      width: 35px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;

      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #585f6d;
      border-radius: 10px;

      cursor: pointer;

      &:not(.active) {
        &:hover {
          opacity: 0.8;
        }
      }

      &.active {
        background: #64748B;
        color: #ffffff;
        cursor: default;
      }
    }

    &-dots {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: default;
    }

    &-item {
    }
  }
}
</style>
